'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _twitterTweetUrl = require('./twitter-tweet-url');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShareLink = function (_React$Component) {
	(0, _inherits3.default)(ShareLink, _React$Component);

	function ShareLink(props) {
		(0, _classCallCheck3.default)(this, ShareLink);

		var _this = (0, _possibleConstructorReturn3.default)(this, (ShareLink.__proto__ || Object.getPrototypeOf(ShareLink)).call(this, props));

		_this.state = {
			link: props.link,
			text: props.text,
			hashtags: props.hashtags,
			via: props.via,
			related: props.related,
			customQueryParams: props.customQueryParams
		};
		return _this;
	}

	(0, _createClass3.default)(ShareLink, [{
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps) {
			if (!_lodash2.default.isEqual(this.props.link, prevProps.link)) {
				this.setState({
					link: this.props.link
				});
			}
			if (!_lodash2.default.isEqual(this.props.text, prevProps.text)) {
				this.setState({
					text: this.props.text
				});
			}
			if (!_lodash2.default.isEqual(this.props.hashtags, prevProps.hashtags)) {
				this.setState({
					hashtags: this.props.hashtags
				});
			}
			if (!_lodash2.default.isEqual(this.props.via, prevProps.via)) {
				this.setState({
					via: this.props.via
				});
			}
			if (!_lodash2.default.isEqual(this.props.related, prevProps.related)) {
				this.setState({
					related: this.props.related
				});
			}
			if (!_lodash2.default.isEqual(this.props.customQueryParams, prevProps.customQueryParams)) {
				this.setState({
					customQueryParams: this.props.customQueryParams
				});
			}
		}
	}, {
		key: 'render',
		value: function render() {
			// TODO: Add a way for users to provide their own url?
			var url = new _twitterTweetUrl.TwitterTweetUrl({
				link: this.state.link,
				text: this.state.text,
				hashtags: this.state.hashtags,
				via: this.state.via,
				related: this.state.related,
				customQueryParams: this.state.customQueryParams
			}).toUrl();

			return this.props.children(url);
		}
	}]);
	return ShareLink;
}(_react2.default.Component);

ShareLink.propTypes = {
	link: _propTypes2.default.string,
	text: _propTypes2.default.string,
	hashtags: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
	via: _propTypes2.default.string,
	related: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
	customQueryParams: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string])
};

ShareLink.defaultProps = {
	link: null,
	text: null,
	hashtags: null,
	via: null,
	related: null,
	customQueryParams: null
};

exports.default = ShareLink;
//# sourceMappingURL=index.js.map